module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SANS FABRIC","short_name":"SANS FABRIC","description":"SANS FABRIC is an India based Textile Fabric Manufacturing and Exporting Company.","lang":"en","start_url":"/","legacy":true,"background_color":"#6b37bf","theme_color":"#6b37bf","cache_busting_mode":"none","display":"standalone","icon":"src/images/icon.png","include_favicon":true,"theme_color_in_head":true,"cacheDigest":null},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
